export default __webpack_public_path__ + "static/media/fridge1-before1-1024w.46e863cd.webp";